import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./test-lib/reportWebVitals";
import Router from "./app/Router";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Router />
  </React.StrictMode>
);

reportWebVitals();
